import { appActions } from 'app/app.actions';
import { AppDispatch } from 'bootstrap.store';
// eslint-disable-next-line no-restricted-imports
import type { ComposeEmailModalFormValues } from 'components/shared/composeEmail/types';

import type { FormValues } from './composeEmailModal.types';

export function convertLegacyToV2InitialValues(
  legacy: ComposeEmailModalFormValues,
): Partial<FormValues> {
  const result: Partial<FormValues> = {};

  if (legacy.toUser?.length) {
    const first = legacy.toUser[0];
    result.toEmail = [
      {
        email: first.user.email || '',
        name: first.user.name ?? first.user.display_name ?? undefined,
        id: first.user.id ?? undefined,
      },
    ];
  }

  if (typeof legacy.fromEmails === 'string' && legacy.fromEmails) {
    result.fromEmail = [legacy.fromEmails];
  }
  if (legacy.linkConversationType) {
    result.linkType = legacy.linkConversationType;
  }
  if (legacy.parentConversation !== undefined) {
    result.parentConversation = legacy.parentConversation;
  }
  if (legacy.subject) {
    result.subject = legacy.subject;
  }
  if (legacy.message) {
    result.body = legacy.message;
  }
  if (legacy.internalNote) {
    result.internalNote = legacy.internalNote;
  }
  if (legacy.tags?.length) {
    result.tags = legacy.tags;
  }
  if (legacy.offer !== undefined) {
    result.offerInQueue = legacy.offer;
  }

  if (legacy.cc?.length) {
    result.cc = legacy.cc.map((u) => ({
      email: u.user.email || '',
      name: u.user.name ?? u.user.display_name ?? undefined,
    }));
  }

  if (legacy.bcc?.length) {
    result.bcc = legacy.bcc.map((u) => ({
      email: u.user.email || '',
      name: u.user.name ?? u.user.display_name ?? undefined,
    }));
  }

  return result;
}

/**
 * Returns the action to open the compose email modal.
 *
 * Accepts the legacy `ComposeEmailModalFormValues` payload, which is converted
 * to `Partial<FormValues>` automatically.
 *
 * Use this in sagas: `yield put(getOpenComposeEmailAction(payload))`.
 */
export function getOpenComposeEmailAction(payload?: {
  initialValues?: ComposeEmailModalFormValues;
}) {
  const initialValues = payload?.initialValues
    ? convertLegacyToV2InitialValues(payload.initialValues)
    : undefined;
  return appActions.showModal.action({
    modal: { type: 'app:composeEmail', arg: { initialValues } },
  });
}

/**
 * Thunk version of {@link getOpenComposeEmailAction} for use in React
 * components.
 */
export const openComposeEmail =
  (payload?: { initialValues?: ComposeEmailModalFormValues }) =>
  (dispatch: AppDispatch): void => {
    dispatch(getOpenComposeEmailAction(payload));
  };
